var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50ZM33.6961 20.6524C33.6961 26.0552 29.8029 30.435 25.0004 30.435C20.1979 30.435 16.3047 26.0552 16.3047 20.6524C16.3047 15.2496 20.1979 10.8698 25.0004 10.8698C29.8029 10.8698 33.6961 15.2496 33.6961 20.6524ZM40.5941 39.0656C36.7508 43.324 31.1879 46.0004 25 46.0004C18.8125 46.0004 13.2501 43.3244 9.40679 39.0666C13.3202 34.9331 18.8594 32.3545 25.0009 32.3545C31.1419 32.3545 36.6808 34.9326 40.5941 39.0656Z",
    fill: "#121622",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultProfile);
export default __webpack_public_path__ + "static/media/icon_default-profile.cd46c775ab6d6901e4c070f071f5c03a.svg";
export { ForwardRef as ReactComponent };